import { render, staticRenderFns } from "./TeamRecord.vue?vue&type=template&id=d635ff26&"
import script from "./TeamRecord.vue?vue&type=script&lang=ts&"
export * from "./TeamRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports